import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

/**
 * Palette blends the BracketsNinja page (blue, --primary-500 #2da0ed) with
 * Trofeo's brand (near-black #0b0f14 + emerald #22c55e): a blue glow on one
 * side, a green glow on the other, and a green CTA carrying Trofeo's identity.
 *
 * Layout: icon + copy on top, full-width centered CTA pinned to the bottom.
 */
export const StyledDiv = styled.div`
	position: relative;
	overflow: hidden;
	margin: 30px 0 10px;
	padding: 28px 24px;
	border-radius: 16px;
	background: linear-gradient(135deg, #0e2236 0%, #0b0f14 55%, #07140d 100%);
	border: 1px solid rgba(34, 197, 94, 0.3);
	box-shadow: 0 18px 40px -24px rgba(7, 12, 16, 0.95);
	text-align: left;

	@media screen and (min-width: ${CSSVars.breakpointMD}) {
		padding: 36px 40px;
		margin: 50px 0 20px;
	}

	/* soft glow accents: green (Trofeo) + blue (BracketsNinja) */
	&::before,
	&::after {
		content: '';
		position: absolute;
		border-radius: 50%;
		filter: blur(60px);
		opacity: 0.5;
		pointer-events: none;
	}

	&::before {
		width: 220px;
		height: 220px;
		top: -90px;
		right: -40px;
		background: rgba(34, 197, 94, 0.45);
	}

	&::after {
		width: 200px;
		height: 200px;
		bottom: -110px;
		left: -50px;
		background: rgba(45, 160, 237, 0.45);
	}

	.trofeo-head {
		position: relative;
		display: flex;
		flex-direction: column;
		gap: 16px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			flex-direction: row;
			align-items: center;
			gap: 24px;
		}
	}

	.trofeo-icon {
		flex-shrink: 0;
		width: 60px;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 32px;
		border-radius: 14px;
		background: linear-gradient(140deg, #2dd66a 0%, #16a34a 100%);
		box-shadow: 0 8px 22px -8px rgba(34, 197, 94, 0.7);

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			width: 72px;
			height: 72px;
			font-size: 38px;
		}
	}

	.trofeo-copy {
		flex: 1;

		.eyebrow {
			display: inline-block;
			margin: 0 0 8px;
			font-family: ${CSSVars.primaryFont};
			font-size: 12px;
			font-weight: 600;
			letter-spacing: 0.12em;
			text-transform: uppercase;
			color: #2dd66a;
		}

		h3 {
			margin: 0 0 8px;
			font-family: ${CSSVars.primaryFont};
			font-size: ${CSSVars.fontSizeXL};
			font-weight: 700;
			line-height: 1.25;
			color: #ffffff;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize2XL};
			}
		}

		p {
			margin: 0;
			font-family: ${CSSVars.secondaryFont};
			font-size: ${CSSVars.fontSizeSM};
			font-weight: 300;
			line-height: 1.6;
			color: rgba(255, 255, 255, 0.82);

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeMD};
			}
		}
	}

	.trofeo-cta {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		margin-top: 24px;
		padding: 18px 28px;
		border-radius: 12px;
		font-family: ${CSSVars.primaryFont};
		font-size: ${CSSVars.fontSizeMD};
		font-weight: 700;
		text-align: center;
		text-decoration: none !important;
		color: #06140c !important;
		background: linear-gradient(140deg, #2dd66a 0%, #16a34a 100%);
		box-shadow: 0 12px 26px -10px rgba(34, 197, 94, 0.85);
		transition: transform 0.18s ease, box-shadow 0.18s ease;

		&:hover {
			transform: translateY(-2px);
			box-shadow: 0 18px 32px -10px rgba(34, 197, 94, 0.95);
		}

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			margin-top: 28px;
			padding: 20px 28px;
			font-size: ${CSSVars.fontSizeLG};
		}
	}
`;
